import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Trans } from 'react-i18next';

const PrivacyPolicy = () => {
  return (
    <>
      <Container>
        <Header />
        <Grid container display='flex' flexDirection='column' sx={{ py: 4, px: { xs: 4, sm: 8, md: 12 }, textAlign: 'justify' }} >
          <Typography variant="h3" sx={{ fontSize: { xs: '2.125rem', sm: '3rem' }, mb: 5, fontWeight: 'bold', textAlign: 'center' }}>
            <Trans i18nKey="privacyPolicy.title" />
          </Typography>

          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.introduction" />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section1.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section1.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section2.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section2.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section3.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section3.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section4.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section4.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section5.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section5.content" />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section6.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section6.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section7.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section7.content" />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section8.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section8.content" />
          </Typography>

          <Typography variant="h5" gutterBottom>
            <Trans i18nKey="privacyPolicy.section9.title" />
          </Typography>
          <Typography variant="body1" paragraph>
            <Trans i18nKey="privacyPolicy.section9.content" />
          </Typography>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
